"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCreator = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var formCompleted_1 = require("./formCompleted");
var formError_1 = require("./formError");
var formStart_1 = require("./formStart");
var creatorMappings = (_a = {},
    _a[analytics_layer_1.FormInteractionEventNames.FormStart] = formStart_1.formStart,
    _a[analytics_layer_1.FormInteractionEventNames.FormCompleted] = formCompleted_1.formCompleted,
    _a[analytics_layer_1.FormInteractionEventNames.FormError] = formError_1.formError,
    _a);
var getCreator = function (eventName) { return creatorMappings[eventName]; };
exports.getCreator = getCreator;
